<template>
  <div class="py-5 lightgray">  
    <div class="text-center">
      <h3 
        style="font-weight: 400;">
        BRANDS YOU DEPEND ON
      </h3>
      <small>From the smallest jobs to new construction, EJ Welch and our key partners can get you to the finish line.</small>
    </div>
    <LetterSelector
      :activeLetter="activeLetter"
      :vendors="vendors"
      @setLetter="setLetter"/>
    <VendorSlider
      :vendors="vendors"
      :activeLetter="activeLetter"/>
  </div>
</template>

<script>
  import LetterSelector from './LetterSelector.vue'
  import VendorSlider from './VendorSlider.vue'
  export default {
    props:['vendors'],
    data(){
      return{
        activeLetter: null
      }
    },
    methods:{
      setLetter(letter){
        this.activeLetter = letter
      }
    },
    components:{
      LetterSelector,
      VendorSlider
    }
  }
</script>

<style scoped>
  .text-red{
    color: #D73E18;
  }
  .lightgray{
    background: lightgray;
  }
</style>


